<div style="display: flex; gap: 20px">
  <div class="row" style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper search-wrapper">
      <div class="mcd-search-header">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Type to search..."
          class="search-input-field"
          value="{{ searchKeyFromParent }}"
          (keyup.enter)="onSearch(key)"
          (input)="(0)"
          (keyup)="(0)"
          #key
        />
        <button
          type="button"
          class="clear-button"
          *ngIf="key.value || searchKeyFromParent"
          (click)="key.value = ''; onSearch(key)"
        >
          <mat-icon class="clear-icon">close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div
          class="dropdown-trigger-btn"
          role="button"
          tabindex="0"
          (click)="toggleDropdown('status')"
          [style]="
            isStatusDropdown || getSelectedItemsCount('status').length > 0
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          "
        >
          <span class="trigger-label">Status</span>
          <span
            class="selected-count-badge"
            *ngIf="getSelectedItemsCount('status').length > 0"
          >
            {{ getDisplayText("status") }}
          </span>
          <button
            type="button"
            class="remove-button"
            *ngIf="getSelectedItemsCount('status').length > 0"
            (click)="clearStatusFilters($event)"
            aria-label="Clear status filter"
          >
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"
            ><img
              src="/assets/images/down-arrow 1.svg"
              height="16px"
              width="16px"
              [style.transform]="
                isStatusDropdown ? 'rotate(180deg)' : 'rotate(0deg)'
              "
              [style.transition]="'transform 0.3s ease'"
          /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isStatusDropdown">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>

          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="statusSearchText"
            (input)="filterStatus()"
            class="search-input"
          />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredStatuses; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox
                [checked]="setCheckedStateForCheckBoxes(item.id)"
                (change)="
                  addOrRemoveFilter($event, item.id, item.name, 'addendumStatus')
                "
                (click)="$event.stopPropagation()"
              >
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div
              class="filter-selected-divider"
              *ngIf="showStatusFilterDivider(filteredStatuses, i)"
            ></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredStatuses.length === 0">
            No Status found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <div style="display: inline-block" *ngIf="showCountryFilter()">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div
          class="dropdown-trigger-btn"
          role="button"
          tabindex="0"
          (click)="toggleDropdown('country')"
          [style]="
            isCountryDropdownOpen || shouldShowMainCountryFilterHighlight()
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          "
        >
          <span class="trigger-label">Country</span>
          <span
            class="selected-count-badge"
            *ngIf="getSelectedItemsCount('country').length > 0"
          >
            {{ getDisplayText('country') }}
          </span>
          <button
            type="button"
            class="remove-button"
            *ngIf="shouldShowMainCountryClearButton()"
            (click)="removeMainCountrySelection($event)"
            aria-label="Clear country filter"
          >
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"
            ><img
              src="/assets/images/down-arrow 1.svg"
              height="16px"
              width="16px"
              [style.transform]="
                isCountryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
              "
              [style.transition]="'transform 0.3s ease'"
          /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isCountryDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="countrySearchText"
            (input)="filterCountries()"
            class="search-input"
          />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredCountries; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox
                [checked]="isCountryFilterChecked(item.id)"
                (change)="onCountryFilterChange($event, item.id)"
                (click)="$event.stopPropagation()"
              >
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div
              class="filter-selected-divider"
              *ngIf="showCountryFilterDivider(filteredCountries, i)"
            ></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredCountries.length === 0">
            No countries found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyCountryFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <div style="flex: 1"></div>
  <div>
    <button class="extract-button" (click)="openExportModal()">
      <img src="/assets/images/export 1.svg" style="margin-right: 5px" />Export
    </button>
  </div>
</div>





<div
  *ngIf="isExportModalOpen"
  class="modal-overlay"
  (click)="closeExportModal()"
>
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2>Export Standards</h2>
      <button class="close-btn" (click)="closeExportModal()">×</button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Equipment Type Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Status</label>
        <div class="export-modal-filter-dropdown-wrapper">
          <div
            class="export-modal-dropdown-header"
            (click)="toggleExportDropdown('status')"
          >
            <button
              class="export-modal-dropdown-trigger-btn buttonArrow"
              [style]="
                isExportStatusDropdownOpen ||
                getExportSelectedItemsCount('status').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              "
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <span
                class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('status').length > 0"
              >
                {{ getExportDisplayText("status") }}
              </span>
              <span *ngIf="getExportSelectedItemsCount('status').length == 0">
                All
              </span>
              <span>
                <img
                  src="/assets/images/down-arrow 1.svg"
                  height="16px"
                  width="16px"
                  [style.transform]="
                    isExportStatusDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  "
                  [style.transition]="'transform 0.3s ease'"
                />
              </span>
            </button>
          </div>

          <!-- Status Options - INSIDE the wrapper with absolute positioning -->
          <div
            class="export-modal-dropdown-content"
            *ngIf="isExportStatusDropdownOpen"
          >
            <div class="export-modal-dropdown-options">
              <ng-container
                *ngFor="let item of filteredStatuses; let i = index"
              >
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox
                    [checked]="setExportCheckedStateForCheckBoxes(1, item.id)"
                    (change)="
                      addExportFilter(
                        $event,
                        item.id,
                        1,
                        item.name,
                        'status'
                      )
                    "
                    (click)="$event.stopPropagation()"
                  >
                    {{item.name}}
                  </mat-checkbox>
                </div>
                <div
                  class="filter-selected-divider"
                  *ngIf="showExportStatusFilterDivider(filteredStatuses, i)"
                ></div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

    


      <!-- Country Dropdfoen -->
      <div class="filter-group" *ngIf="showCountryFilter()">
        <label class="filter-label">Country</label>
        <div class="export-modal-filter-dropdown-wrapper">
          <div
            class="export-modal-dropdown-header"
            (click)="toggleExportDropdown('country')"
          >
            <button
              class="export-modal-dropdown-trigger-btn buttonArrow"
              [style]="
                isExportCountryDropdownOpen 
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              "
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <span
                class="export-modal-selected-count-badge"
              *ngIf="ExportselectedCountryIds.length > 0"
              >
                {{ getCountryDisplayText() }}
              </span>
              <span *ngIf="ExportselectedCountryIds.length ==  0">
                All
              </span>
              <span>
                <img
                  src="/assets/images/down-arrow 1.svg"
                  height="16px"
                  width="16px"
                  [style.transform]="
                    isExportCountryDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  "
                  [style.transition]="'transform 0.3s ease'"
                />
              </span>
            </button>
          </div>

          <!-- Location Options - INSIDE the wrapper with absolute positioning -->
          <div
            class="export-modal-dropdown-content"
            *ngIf="isExportCountryDropdownOpen"
          >
            <div class="export-modal-dropdown-options">
              <ng-container
                *ngFor="let item of filteredCountries | slice:1; let i = index"
              >
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox
                    [checked]="isCountrySelected(item.id)"
                    (change)="onCountrySelectionChange($event, item.id)"
                    (click)="$event.stopPropagation()"
                  >
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div
                  class="filter-selected-divider"
                  *ngIf="
                    showExportCountryFilterDivider(
                      filteredCountries | slice: 1,
                      i
                    )
                  "
                ></div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
   
    </div>

    <!-- Modal Footer with Buttons -->
    <div class="export-modal-footer">
      <button class="export-modal-cancel-btn" (click)="closeExportModal()">
        Cancel
      </button>
      <button class="export-modal-export-btn" (click)="applyExportFilters()">
        <img
          src="/assets/images/export-black.svg"
          style="
            margin-bottom: 2px;
            margin-right: 4px;
            height: 12px;
            width: 12px;
          "
        />Export
      </button>
    </div>
  </div>
</div>